import { render, staticRenderFns } from "./ModalAddRedemption.vue?vue&type=template&id=1147a29c"
import script from "./ModalAddRedemption.vue?vue&type=script&lang=js"
export * from "./ModalAddRedemption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports